import {gql, useLazyQuery } from "@apollo/client";
import {useLogger} from "./useLogger";
import {getBrowser} from "../common/common";

const resortRestaurantsByResortId = gql`query ResortRestaurants($hapimagResortId: Int!, $locale: String!) {
    resortRestaurantCollection(where: {resort: {hapimagResortId: $hapimagResortId}}, locale: $locale, order: order_ASC, limit: 10) {
        items {
            imagesCollection {
				items {
                    url
					sys {
						id
					}
                }
			}
			title
			phoneNumber
			emailAddress
			website
			openingHours
			openingHoursExtraInfo
			menuCollection {
				items {
					title
					document {url}
				}
			}
            sys {
                id
            }
        }
    }
}`;

export const useResortRestaurants = () => {
    const {logger} = useLogger();

    const [getResults, { loading, data, error }] = useLazyQuery(resortRestaurantsByResortId, {
        fetchPolicy: getBrowser() === "Safari" ? "network-only" : "cache-first",
        errorPolicy: "all"
    });

    const results = data?.resortRestaurantCollection?.items;

    if (error?.message) {
        logger(error?.message, "error", "useResortRestaurants", error?.stack);
    }

    return {
        getResortRestaurants: getResults,
        resortRestaurants: results,
        loadingResortRestaurants: loading,
        errorResortRestaurants: error
    };
};
